import React, { useState } from 'react';
import { Form, useChanges } from '../../../components/Form/Form';
import { ModalController } from '../../../components/Modal/ControlledModal';
import { User } from '../../../model/user';
import { Company } from '../../../model/company';
import { handleError } from '../../../model/notification';
import { AsyncSearch } from '../../../components/Form/AsyncSearch/AsyncSearch';
import { createOrder } from '../../../model/order';
import { t } from '../../../locales/translate';
import { Collection } from '../../../model/data';

interface Props {
  controller: ModalController<{ user: User | Company }>;
}

export function CreateOrder({ controller }: Props): JSX.Element {
  const [, , order, trackChanges] = useChanges<{
    user?: User | Company;
  }>({});

  const [selectedUser, setSelectedUser] = useState<Collection | undefined>(undefined);

  async function handleOnSubmit(): Promise<void> {
    if (selectedUser) {
      try {
        await createOrder(selectedUser);
      } catch (error) {
        handleError(error);
      }
    }
  }

  controller.configure({
    onSubmit: handleOnSubmit,
    canSubmit: !!selectedUser,
  });

  return (
    <Form model={order} onInput={trackChanges}>
      <AsyncSearch
        label={`${t.model.user.customer} / ${t.model.company.vendor}`}
        name="user"
        searchIn={['user', 'company']}
        onSelect={(item) => setSelectedUser(item as Collection)}
        required
      />
    </Form>
  );
}
